import config from '@/config';

export default {
    baseUrl: `${config.server.host}:${config.server.port}/api-v2`,
    baseUrlWithoutApi: `${config.server.host}:${config.server.port}`,
    baseUrlWallet: `${config.wallet.host}:${config.wallet.port}`,
    baseURLQr: `${config.walletQr.host}/api-v2`
}
